import { toString as queryfilterToString } from '@gonfalon/queryfilter/builder';
import type { PostContextsParams } from '@gonfalon/rest-api/types';

import type { UIContextsView } from '../types/types';

export function serializeUIContextsViewForAPI(ui: UIContextsView) {
  const api: PostContextsParams = {};
  if (ui.filter) {
    api.filter = queryfilterToString(ui.filter);
  }
  return api;
}
